import React, { Component } from 'react'
import AboutUs from '../components/AboutUs'
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { getSEO } from "../services/seoService";



export class About extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          seo: null,
        };
      }
    
    async componentDidMount() {
        const seoData = await getSEO("about");
    
        this.setState({
          seo: seoData,
        });
    }
  render() {
    return (
      <div>
        <SEO seo={this.state.seo} />

          {/* Hero Start */}
          <div className="container-fluid pb-5 hero-header mb-5">
              <div className="container py-5">
                  <div className="row g-3 align-items-center">
                      <div className="col-lg-6 text-center text-lg-start">
                          <h1 className="display-3 mb-0 animated slideInLeft">About Us</h1>
                      </div>
                      <div className="col-lg-6 animated slideInRight">
                          <nav aria-label="breadcrumb">
                              <ol className="breadcrumb justify-content-center justify-content-lg-end mb-0">
                                  <li className="breadcrumb-item"><Link className="text-secondary" to="/">Home</Link></li>
                                  <li className="breadcrumb-item active" aria-current="page">About</li>
                              </ol>
                          </nav>
                      </div>
                  </div>
              </div>
          </div>
          {/* Hero End */}
          <AboutUs/>
      </div>
    )
  }
}

export default About
